import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { contentFont, headingFont } from '../../styles/fontStyles';
import { appTheme, pitchTheme } from '../../styles/theme';

export const LegalPage = styled.main`
  flex: 1;
  padding: 32px 24px 48px;
  background: ${appTheme.pageBg};
`;

export const LegalContainer = styled.div`
  max-width: 720px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const LegalHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LegalMeta = styled.p`
  margin: 0;
  font-size: 0.8125rem;
  color: ${pitchTheme.textMuted};
`;

export const LegalBody = styled.div`
  ${contentFont}
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 28px;
  border-radius: 14px;
  border: 1px solid ${pitchTheme.border};
  background: #fff;
  box-shadow: 0 8px 24px rgba(5, 21, 84, 0.06);
  color: ${pitchTheme.text};
  font-size: 0.9375rem;
  line-height: 1.65;

  h2 {
    margin: 0 0 8px;
    ${headingFont}
    font-size: 1.0625rem;
    color: ${pitchTheme.text};
  }

  p {
    margin: 0;
  }

  ul {
    margin: 0;
    padding-left: 1.25rem;
  }

  li + li {
    margin-top: 6px;
  }

  a {
    color: ${pitchTheme.blueDark};
  }
`;

export const LegalSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BackLink = styled(Link)`
  align-self: flex-start;
  font-size: 0.8125rem;
  font-weight: 600;
  color: ${pitchTheme.blueDark};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
